import { asText, Content, isFilled } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import styles from 'components/PRISMIC/scss/pages.module.scss';
import classNames from 'classnames';

import TwitterIcon from './icons/circle-twitter-fill.svg';
import FacebookIcon from './icons/circle-facebook-fill.svg';
import EmailIcon from './icons/circle-email-fill.svg';
import LinkedInIcon from './icons/circle-linkedin-fill.svg';

import type { JSX } from 'react';

const PLATFORMS = [
  {
    name: 'X',
    Icon: TwitterIcon,
    css: styles['icon-twitter'],
    link: (customShareMessage: string, url: string) =>
      `//twitter.com/intent/tweet?url=${url}%3Futm_campaign%3Dtedspread%26utm_medium%3Dreferral%26utm_source%3Dtedcomshare&via=TEDTalks&amp&text=${customShareMessage}`
  },
  {
    name: 'Facebook',
    Icon: FacebookIcon,
    css: styles['icon-facebook'],
    link: (customShareMessage: string, url: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${url}%3Futm_campaign%3Dtedspread%26utm_medium%3Dreferral%26utm_source%3Dtedcomshare`
  },
  {
    name: 'EmailIcon',
    Icon: EmailIcon,
    css: styles['icon-email'],
    link: (customShareMessage: string, url: string) =>
      `mailto:?subject=${customShareMessage}&body=${url}%3Futm_campaign%3Dtedspread%26utm_medium%3Dreferral%26utm_source%3Dtedcomshare`
  },
  {
    name: 'LinkedInIcon',
    Icon: LinkedInIcon,
    css: styles['icon-linkedin'],
    link: (customShareMessage: string, url: string) =>
      `http://www.linkedin.com/shareArticle?mini=true&url=${url}%3Futm_campaign%3Dtedspread%26utm_medium%3Dreferral%26utm_source%3Dtedcomshare&title=${customShareMessage}&source=ted.com`
  }
];

/**
 * Props for `SocialSharing`.
 */
export type SocialSharingProps =
  SliceComponentProps<Content.SocialSharingSlice>;

/**
 * Component for "SocialSharing" Slices.
 */
const SocialSharing = ({ slice }: SocialSharingProps): JSX.Element => {
  return (
    <div
      className={styles['pages-share']}
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {PLATFORMS.map(({ name, Icon, css, link }) => (
        <a
          className={classNames(styles.icon, css, 'mx-1 cursor-pointer')}
          key={name}
          data-service={name.toLowerCase()}
          href={link(
            encodeURIComponent(
              isFilled.richText(slice.primary.custom_share_message)
                ? asText(slice.primary.custom_share_message)
                : ''
            ),
            encodeURIComponent(
              isFilled.richText(slice.primary.custom_share_url)
                ? asText(slice.primary.custom_share_url)
                : ''
            )
          )}
          target="_blank"
          rel="noreferrer"
        >
          <i title={`Share on ${name}`}>
            <Icon />
          </i>
        </a>
      ))}
    </div>
  );
};

export default SocialSharing;
